export default {
    usuarios: state => state.lista
}